export default "__VITE_ASSET__71de3a2e__"